import { createContext, useContext, useState, useCallback, ReactNode } from 'react';

interface PageLoadingContextType {
  isPageLoading: boolean;
  startPageLoading: () => void;
  stopPageLoading: () => void;
}

const PageLoadingContext = createContext<PageLoadingContextType | undefined>(undefined);

export function PageLoadingProvider({ children }: { children: ReactNode }) {
  const [isPageLoading, setIsPageLoading] = useState(false);

  const startPageLoading = useCallback(() => {
    setIsPageLoading(true);
  }, []);

  const stopPageLoading = useCallback(() => {
    setIsPageLoading(false);
  }, []);

  return (
    <PageLoadingContext.Provider value={{ isPageLoading, startPageLoading, stopPageLoading }}>
      {/* Preloader global - igual ao Rails */}
      {isPageLoading && (
        <div className="preloader" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <svg className="circular" viewBox="25 25 50 50">
            <circle className="path" cx="50" cy="50" r="20" fill="none" strokeWidth="2" strokeMiterlimit="10" />
          </svg>
        </div>
      )}
      {children}
    </PageLoadingContext.Provider>
  );
}

export function usePageLoading() {
  const context = useContext(PageLoadingContext);
  if (context === undefined) {
    throw new Error('usePageLoading must be used within a PageLoadingProvider');
  }
  return context;
}
